import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import { FormGroup, FormControl, InputGroup } from 'react-bootstrap';

export default class PasswordField extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            errors: false,
            touched_and_blank: false,
            value: '',
            class_names: '',
            redirect: false,
            cookie: '',
            redirect_url:''
        }
    }

    componentDidMount = () => {
        //console.log('CharField componentDidMount');
        this.setState({value: this.props.editingInstance[this.props.field_id]});
        if (this.props.focus === this.props.field_id) {
            $(`#${this.props.field_id}`).focus();
        }
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          this.handleSubmitClick();
        }
    }

    onChange = (e) => {
        // if (this.setErrorTimer) {
        //     clearTimeout(this.setErrorTimer);
        // }
        let data_key = e.target.name;
        let key = this.props.field_id; //.replace(/ /g,"_");
        //let value = $.trim(e.target.value);
        let value = e.target.value;
        this.setState({value});
        // this.setErrorTimer = setTimeout(() => {
        //   this.props.onSelectChange(key, value);
        // }, 750);
        this.props.onSelectChange(key, value);
    }

    getCookie = (c_name) => {
        if(document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if(c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if(c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start,c_end));
            }
        } else {
            return "";
        }
    }

    handleSubmitClick = () => {
      let cookie = this.getCookie('csrftoken');
        let editingInstance = this.props.editingInstance;
        if (this.props.add_csrf_cookie === true) {
            editingInstance['csrfmiddlewaretoken'] = cookie;
        }
        if (this.props.add_csrf_to_header === true) {
          $.ajax({
            headers: {"X-CSRFToken": cookie}
          })
        }
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            method: 'POST',
            data: editingInstance,
            cache: false,
            statusCode: {
               403: () => {
                 this.setState({redirect_url: '/login/', redirect: true})
               }
            },
            success: (data) => {
              this.setState({redirect: true, redirect_url:this.props.redirect_url})
              this.props.clearEditingInstance();
              this.props.setMessage(this.props.success_message, 'success');
            },
            error: (xhr, status, err) => {
              this.setState({redirect_url: this.props.failed_redirect_url, redirect: true})
              this.props.clearEditingInstance();
              this.props.setMessage(this.props.failed_message, 'danger');
            }
        });
    }

    render() {
        if (this.state.redirect === true) {
            return <Redirect to={this.state.redirect_url} />;
        }
        return (
          <FormGroup controlId='largeinput horizontalpassword' bsSize="large">
              <InputGroup>
                  <InputGroup.Addon style={this.props.input_group_addon_style}>
                      <i className={this.props.icon_class} style={this.props.style}/>
                  </InputGroup.Addon>
                  <FormControl
                      type={this.props.type}
                      id={`${this.props.field_id}`}
                      placeholder={this.props.field_id}
                      required
                      autoFocus={this.props.autoFocus}
                      value={this.state.value}
                      onChange={this.onChange}
                      onKeyDown={this.handleKeyDown}
                  />
              </InputGroup>
          </FormGroup>
        );
    }
}

PasswordField.propTypes = {
    editingInstance: PropTypes.node,
    redirect_url: PropTypes.node,
    message: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/field/password_field.js